<template>
  <form @submit.prevent="submitForm">
    <h2 :class="style['user-title']">
      {{ $t('reset_password.title') }}
    </h2>

    <figure role="group">
      <p :class="style['chat-message']">
        {{ $t('forgotten_password.information') }}
      </p>
      <figure-caption-user :settings="settings" />
    </figure>

    <label for="email" :class="style['user-label']">
      <input
        id="email"
        v-model="inputEmail"
        type="email"
        placeholder=" "
        :class="style['user-input']"
        @input="resetErrorMessages()"
      />
      <span :class="style['field-name']">{{ $t('forgotten_password.email_placeholder') }}</span>
    </label>

    <p :class="style[errorMessage.cssClass]">
      {{ errorMessage.message }}
      <a
        v-if="errorMessage.linkText !== ''"
        href="#"
        @click.prevent="goToUserComponent('SignIn')"
        >{{ errorMessage.linkText }}</a
      >
    </p>

    <input
      type="submit"
      :class="[style['user-input'], style['submit-button']]"
      :value="$t('forgotten_password.submit')"
      :disabled="isSending"
    />
  </form>
</template>

<script>
import { User } from 'src/apis'
import FigureCaptionUser from './FigureCaptionUser.vue'
import style from './scss/_users.scss'

export default {
  components: {
    FigureCaptionUser
  },
  props: {
    settings: { type: Object, required: true },
    goToUserComponent: { type: Function, required: true }
  },
  data: function () {
    return {
      inputEmail: '',
      errorMessage: {
        cssClass: 'error-text',
        message: '',
        linkText: ''
      },
      isSending: false,
      style
    }
  },

  methods: {
    submitForm() {
      this.isSending = true
      User.SendForgottenPasswordRequest(this.inputEmail)
        .then((json) => {
          this.isSending = false
          this.errorMessage.cssClass = 'form-text'
          this.errorMessage.message = this.$t('forgotten_password_confirmation.information')
          this.errorMessage.linkText = this.$t('sign_in')
        })
        .catch((error) => {
          this.isSending = false
          if (error.xhr.status === 404) {
            this.errorMessage.cssClass = 'error-text'
            this.errorMessage.message = this.$t('forgotten_password.error')
            this.errorMessage.linkText = ''
          }
          console.error(error)
        })
    },
    resetErrorMessages() {
      this.errorMessage.cssClass = 'error-text'
      this.errorMessage.message = ''
      this.errorMessage.linkText = ''
    }
  }
}
</script>
